require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./learning-educational-programs-and-curriculum.json") })
        }
      }, "path---learning-educational-programs-and-curriculum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---learning-educational-programs-and-curriculum!./.cache/json/learning-educational-programs-and-curriculum.json
// module id = 1238
// module chunks = 231608221292675